import {DisplaySet} from '../../displaySet/model/DisplaySet'
import {CodificationSystem} from './CodificationSystem'
import {ClassificationType} from '../../item/model/ClassificationType'

export enum OrganizationStatusEnum {
    ACTIVE = 'ACTIVE',
    STOPPED = 'STOPPED',
    REPLACED = 'REPLACED'
}

export interface Organization {
    label: string
    acronym: string
    id: string
    category: ClassificationType,
    displaySets?: DisplaySet[],
    codificationSystem: CodificationSystem,
    createdDate: Date,
    code: string,
    status: OrganizationStatusEnum,
}
